import { render, staticRenderFns } from "./shenheYuce.vue?vue&type=template&id=1ba3c20e&scoped=true"
import script from "./shenheYuce.vue?vue&type=script&lang=js"
export * from "./shenheYuce.vue?vue&type=script&lang=js"
import style0 from "./shenheYuce.vue?vue&type=style&index=0&id=1ba3c20e&prod&scoped=true&lang=css"
import style1 from "./shenheYuce.vue?vue&type=style&index=1&id=1ba3c20e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba3c20e",
  null
  
)

export default component.exports